import { render, staticRenderFns } from "./PCCCards.vue?vue&type=template&id=ff6193d6&scoped=true&"
import script from "./PCCCards.vue?vue&type=script&lang=js&"
export * from "./PCCCards.vue?vue&type=script&lang=js&"
import style0 from "./PCCCards.vue?vue&type=style&index=0&id=ff6193d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6193d6",
  null
  
)

export default component.exports